const SHIFT_DOMAIN = 'shift'

export function isShift(): boolean {
  const host = window?.location.hostname
  return host?.includes(SHIFT_DOMAIN)
}
